import React from 'react';
import { motion } from 'framer-motion';
export function EmotionGuide() {
  return <section className="py-12 px-4 bg-cream" data-id="element-132">
      <div className="max-w-4xl mx-auto" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-134">
          <p className="text-lg md:text-xl text-navy/80 leading-relaxed font-medium max-w-3xl mx-auto" data-id="element-135">
            El libro no solo explica lo que sientes.
          </p>
          <p className="text-lg md:text-xl text-navy/80 leading-relaxed font-medium max-w-3xl mx-auto mt-2" data-id="element-136">
            También te muestra cómo convertir esa emoción en comunicación clara.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative" data-id="element-137">
          <div className="absolute inset-0 bg-terracotta/10 transform -rotate-1 rounded-2xl" data-id="element-138" />
          <img src="https://cdn.magicpatterns.com/uploads/v6QjmeQuAT9JRCYmnEvxUT/image.png" alt="Guía Práctica: De Emoción a Petición — 4 pasos para comunicar con claridad" className="relative rounded-2xl shadow-xl w-full" data-id="element-139" />
        </motion.div>

        <p className="text-center text-lg md:text-xl text-navy/70 italic font-medium mt-6" data-id="element-140">
          Encontrarás guías prácticas como esta para convertir el agotamiento en
          conversaciones claras.
        </p>
      </div>
    </section>;
}